<!--超级教研员-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="iframe-wrapper" >
            <div v-if="openUrl" class="back-btn cursor" @click="goBackIframe">
                <span>AI教研中心</span>
            </div>
            <iframe ref="aiIframe" v-if="openUrl" :src="openUrl" frameborder="0" ></iframe>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import {gainXjUrl} from "@/api/admin/aiHome";

export default {
    components: {homeHead},
    name: "homeAiInstructor",
    data() {
        return {
           userInfo : JSON.parse(this.$storage.get("userInfo")),
           openUrl:'',
           loading: true,
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.superTeacher();
    },
    methods: {
        goBackIframe(){
            const iframe = this.$refs.aiIframe;
            if (!iframe || !iframe.contentWindow) return;
            try {
                iframe.contentWindow.history.back();
            } catch (e) {
                // 跨域时浏览器禁止访问 iframe 的 history，无法回退上一页，重置回平台初始页
                iframe.src = this.openUrl;
            }
        },
       superTeacher(){
            gainXjUrl({userId: this.userInfo.userId}).then(res => {
                if (res.data.code === 1){
                    this.openUrl = res.data.data + this.$storage.get("token");
                }else {
                    this.loading = false;
                    this.$message({message: res.data.msg || '操作失败', type: 'info'});
                }
            })
            
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.iframe-wrapper {
    flex: 1;
    margin-top: 20px;
    position: relative;
    .back-btn {
        position: absolute;
        top: 75px;
        right: 12px;
        z-index: 10;
        display: flex;
        align-items: center;
        padding: 6px 14px;
        border-radius: 16px;
        background: #0d55a4;
        color: #fff;
        font-size: 14px;
        .el-icon {
            margin-right: 4px;
        }
        &:hover {
            font-weight: bold;
        }
    }
    iframe {
        width: 100%;
        height: 100%;
        display: block;
        border: none;
    }
}
</style>
